import * as d3 from 'd3-selection';

let Plotly;

// eslint-disable-next-line import/prefer-default-export
export async function importPlotly() {
  // Return the existing libraries if it has already been imported
  if (Plotly && d3) {
    return Promise.resolve({
      Plotly,
      d3,
    });
  }

  return import(/* webpackChunkName: "plotly" */ 'plotly.js-basic-dist')
    .then(({ default: plotly }) => {
      Plotly = plotly;

      return Promise.resolve({
        Plotly,
        d3,
      });
    });
}
